import { colors, Skeleton, styled, TableCell, TableRow } from "@mui/material";
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';
import { useEffect, useRef, useState } from "react";

const TableCellRate = ({ rate, currency, fractionDigits = 2, isLoading = false, bgColor = colors.grey[100], skeletonWidth = 100, style={}, isSelected }) => {

  function formatRate(rate) {
    if (rate === '-') {
      return rate;
    }

    if (isNaN(rate) || rate == 'Unavailable' || typeof rate === 'string') {
      return <span style={{ color: '#f44336' }}>{'Unavailable'}</span>
    }

    if (isNaN(rate)) {
      return rate;
    }

    return getCurrencySign() + rate.toLocaleString('en-PH', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
  }

  function getCurrencySign() {
    if (currency === 'USD') {
      return '$';
    } else if (currency === 'EURO') {
      return '€';
    } else if (currency === 'GBP') {
      return '£';
    } else if (currency === 'SGD') {
      return 'S$';
    } else if (currency === 'AUD') {
      return 'AU$';
    } else if (currency === 'PHP') {
      return '₱';
    }

    return '';
  }

  // const StyledTableCell = styled(TableCell)(({ theme }) => ({
  //   [`&.${tableCellClasses.body}`]: {
  //     border: '2px solid #fff',
  //     backgroundColor: bgColor,
  //   },
  // }));

  const styleObj = {
    border: '2px solid #fff',
    backgroundColor: isSelected ? `linear-gradient(to bottom right, #2196f345, #2196f345), ${bgColor}` : bgColor,
    ...style
  };

  const sxObj = {
    position: "relative",
    "&::after": isSelected
      ? {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: "#2196f3",
          opacity: 0.5,
          pointerEvents: "none",
        }
      : {},
  };

  return isLoading ? <TableCell style={styleObj} sx={sxObj}><Skeleton variant="rounded" width={skeletonWidth} height={20} /></TableCell>
    : <TableCell style={styleObj} sx={sxObj}>{formatRate(rate)}</TableCell>;
};

export default TableCellRate;